import React from "react";
/**
 * Render the the navigation dropdowns.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function DropdownNav(props) {
    return React.createElement("div", { ...props });
}
//# sourceMappingURL=DropdownNav.js.map